import { useTranslation } from 'react-i18next';
import { Link, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export function NotFoundPage() {
  const { t } = useTranslation('public');
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col">
      <Header />

      <main className="global-container flex-1 py-12 md:py-16">
        <div className="max-w-md border-t-2 border-ink pt-4">
          <span className="font-mono text-xs text-accent-text">404</span>
          <h1 className="m-0 mt-2">{t('notFound.title')}</h1>
          <p className="m-0 mt-3 text-sm leading-relaxed text-ink-2">
            {t('notFound.description')}
          </p>
          <p className="m-0 mt-1 break-all font-mono text-xs text-ink">{location.pathname}</p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/" className="text-link">
              {t('notFound.home')}
            </Link>
            <Link to="/calendar" className="text-link">
              {t('nav.calendar')}
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
